/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React from 'react';
import "../../CSS/DataModal.css";

class WarningModal extends React.Component {

    onClick = e => {
        this.props.onClick && this.props.onClick(e);
    };

    onCancelClick() {

    };

    render() {

        if (!this.props.show) {
            return null;
        }
        else {

            return (
                <div className="modal" style={{ display: this.props.show ? "block" : "none" }}>
                    <div className="modal-wrapper"
                        style={{
                            transform: this.props.show ? 'translateY(0vh)' : 'translateY(-100vh)',
                            opacity: this.props.show ? '1' : '0'
                        }}>

                        <div className="modal-header">
                            <h3>{this.props.title}</h3>
                            <span className="close-modal-btn" onClick={e => { this.onClick(e); this.onCancelClick(); }}>×</span>
                        </div>

                        <div className="modal-body">
                            <br/>
                            <p>{this.props.message}</p>
                        </div>

                        <div className="modal-footer">
                            <button className="primary-btn btn-small" onClick={e => { this.onClick(e); this.onCancelClick(); }}>OK</button>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

export default WarningModal;